import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		roleMenus:JSON.parse(sessionStorage.getItem('roleMenus')),
		selectMenus:[]
	},
	mutations: {
		onRoleMenus: (state, obj) => {
			state.roleMenus = obj.list;
		},
		onSelectMenus: (state, obj) => {
			state.selectMenus = obj.list;
		},
	},
	actions: {

	}
})
